var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "moon_svg__a",
    d: "M0 0h27v27H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(10.5 10.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "moon_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#moon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.91 27c5.8 0 11.04-3.655 13.047-9.093a.731.731 0 0 0-.17-.762.727.727 0 0 0-.76-.164 12.37 12.37 0 0 1-4.316.767c-6.87 0-12.459-5.588-12.459-12.459 0-1.485.256-2.936.767-4.315a.718.718 0 0 0-.164-.762.73.73 0 0 0-.762-.169C3.655 2.05 0 7.29 0 13.09 0 20.761 6.239 27 13.91 27",
    mask: "url(#moon_svg__b)"
  })))));
};
export default SvgMoon;